// extracted by mini-css-extract-plugin
var _1 = "InfoIcon__backdrop--niLOR";
var _2 = "InfoIcon__icon--aANrN";
var _3 = "InfoIcon__iconModal--DVmbA InfoIcon__icon--aANrN";
var _4 = "InfoIcon__info--rJMKv OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _5 = "InfoIcon__modal--oMHqB OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _6 = "InfoIcon__modalText--FNi8A OfficeGeneral__textSizeB--Ye78Y CoreGeneral__textSizeB--joAuE";
var _7 = "InfoIcon__qCircle--Ml5iR";
var _8 = "InfoIcon__qSvg--SgmTY";
var _9 = "InfoIcon__qq--KqlDC";
var _a = "InfoIcon__red--IrE3c";
var _b = "InfoIcon__title--u4Cr0 OfficeGeneral__textSizeA--ZYpjj CoreGeneral__textSizeA--JbJdW OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
export { _1 as "backdrop", _2 as "icon", _3 as "iconModal", _4 as "info", _5 as "modal", _6 as "modalText", _7 as "qCircle", _8 as "qSvg", _9 as "qq", _a as "red", _b as "title" }
